import {createComment} from '../../models/comment';
import {isNil} from '../../utils/helpers';

export const commentMapper = {
  toDomain: props => createComment({
    recentlyAdded: false,
    ...props
  }),

  toApi: (text, parentCommentId, article) => {
    const resultObj = {
      text,
      article
    };

    return isNil(parentCommentId) ? resultObj : {...resultObj, parentCommentId};
  }
};
